var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconVacancy = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 18,
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2038_32146)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.625 9C8.41789 9 8.25 9.16789 8.25 9.375V10.125C8.25 10.3321 8.41789 10.5 8.625 10.5H9.375C9.58211 10.5 9.75 10.3321 9.75 10.125V9.375C9.75 9.16789 9.58211 9 9.375 9H8.625Z",
  fill: "#CCE3F0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.75 4.5C16.1642 4.5 16.5 4.83579 16.5 5.25V15C16.5 15.4142 16.1642 15.75 15.75 15.75H2.25C1.83579 15.75 1.5 15.4142 1.5 15V5.25C1.5 4.83579 1.83579 4.5 2.25 4.5H6V2.25C6 1.83579 6.33579 1.5 6.75 1.5H11.25C11.6642 1.5 12 1.83579 12 2.25V4.5H15.75ZM15 14.25H3V12.75H15V14.25ZM10.5 4.5V3H7.5V4.5H10.5ZM15 6H3V11.25H15V6Z",
  fill: "#CCE3F0"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2038_32146"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white"
})))));
export default SvgIconVacancy;